import type { Observable } from 'rxjs';

export type CitizenLoginMode = 'phone' | 'login';

export interface CitizenSessionResponse {
  readonly authenticated: boolean;
  readonly displayName?: string;
  readonly initials?: string;
}

export interface CitizenRegistrationCommand {
  readonly username: string;
  readonly phone: string;
  readonly email: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly password: string;
  readonly locale: 'kk' | 'ru' | 'en';
}

export abstract class CitizenAuthGateway {
  abstract login(mode: CitizenLoginMode, identifier: string, password: string): Observable<void>;
  abstract register(command: CitizenRegistrationCommand): Observable<void>;
  abstract forgotPassword(identifier: string, locale: 'kk' | 'ru' | 'en'): Observable<void>;
  abstract forgotLogin(email: string, phone: string, locale: 'kk' | 'ru' | 'en'): Observable<void>;
  abstract session(): Observable<CitizenSessionResponse>;
  abstract logout(): Observable<void>;
}
